import ListWidget from './ListWidget.vue';
import WidgetDate from './WidgetDate.vue';
import WidgetText from './WidgetText.vue';
import WidgetImage from './WidgetImage.vue';
import WidgetSpacer from './WidgetSpacer.vue';
import WidgetStack from './WidgetStack.vue';

export default {
	ListWidget,
	WidgetDate,
	WidgetText,
	WidgetImage,
	WidgetSpacer,
	WidgetStack,
};